import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";

export default function InProgress() {
  return (
    <Stack
      gap={2}
      justifyContent="center"
      alignItems="center"
      sx={{ background: "var(--white)", p: "24px", borderRadius: "8px" }}
    >
      <Typography
        variant="body1"
        fontWeight={700}
      >
        Hệ thống đang xử lý...
      </Typography>
      <CircularProgress />
    </Stack>
  );
}
